var de = {
	"neptune.Button.loadingAriaLabel": "wird geladen",
	"neptune.Chips.ariaLabel": "{choice} zurücksetzen",
	"neptune.ClearButton.ariaLabel": "Zurücksetzen",
	"neptune.CloseButton.ariaLabel": "Schließen",
	"neptune.DateInput.day.label": "Tag",
	"neptune.DateInput.day.placeholder": "TT",
	"neptune.DateInput.month.label": "Monat",
	"neptune.DateInput.year.label": "Jahr",
	"neptune.DateInput.year.placeholder": "JJJJ",
	"neptune.DateLookup.day": "Tag",
	"neptune.DateLookup.goTo20YearView": "Zur 20-Jahres-Ansicht",
	"neptune.DateLookup.month": "Monat",
	"neptune.DateLookup.next": "weiter",
	"neptune.DateLookup.previous": "zurück",
	"neptune.DateLookup.selected": "ausgewählt",
	"neptune.DateLookup.twentyYears": "20 Jahre",
	"neptune.DateLookup.year": "Jahr",
	"neptune.FlowNavigation.back": "zurück zum vorherigen Schritt",
	"neptune.Info.ariaLabel": "Weitere Informationen",
	"neptune.Label.optional": "(Optional)",
	"neptune.Link.opensInNewTab": "(wird in einem neuen Tab geöffnet)",
	"neptune.MoneyInput.Select.placeholder": "Wähle eine der Möglichkeiten aus...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Wähle eine Währung",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Wähle eine Option...",
	"neptune.Select.searchPlaceholder": "Wird gesucht...",
	"neptune.SelectInput.noResultsFound": "Keine Ergebnisse gefunden",
	"neptune.SelectOption.action.label": "Auswählen",
	"neptune.SelectOption.selected.action.label": "Ausgewählte Option ändern",
	"neptune.StatusIcon.iconLabel.error": "Fehler:",
	"neptune.StatusIcon.iconLabel.information": "Auskünfte:",
	"neptune.StatusIcon.iconLabel.pending": "Ausstehend:",
	"neptune.StatusIcon.iconLabel.success": "Erfolgreich:",
	"neptune.StatusIcon.iconLabel.warning": "Warnung:",
	"neptune.Summary.statusDone": "Schritt erledigt",
	"neptune.Summary.statusNotDone": "Schritt noch zu erledigen",
	"neptune.Summary.statusPending": "Schritt ausstehend",
	"neptune.Table.actionHeader": "Aktion",
	"neptune.Table.emptyData": "Keine Ergebnisse gefunden",
	"neptune.Table.loaded": "Tabellendaten wurden geladen",
	"neptune.Table.loading": "Tabellendaten werden geladen",
	"neptune.Table.refreshPage": "Seite aktualisieren",
	"neptune.Upload.csButtonText": "Eine andere Datei hochladen?",
	"neptune.Upload.csFailureText": "Hochladen fehlgeschlagen. Bitte versuche es erneut",
	"neptune.Upload.csSuccessText": "Fertig hochgeladen!",
	"neptune.Upload.csTooLargeMessage": "Bitte wähle eine Datei aus, die kleiner als {maxSize} MB ist",
	"neptune.Upload.csWrongTypeMessage": "Dateityp wird nicht unterstützt. Bitte versuche es erneut mit einer anderen Datei",
	"neptune.Upload.psButtonText": "Abbrechen",
	"neptune.Upload.psProcessingText": "Wird hochgeladen...",
	"neptune.Upload.retry": "Erneut versuchen",
	"neptune.Upload.usButtonText": "Oder wähle eine Datei aus",
	"neptune.Upload.usDropMessage": "Datei zum Hochladen in dieses Feld ziehen",
	"neptune.Upload.usPlaceholder": "Zieh eine Datei in dieses Feld, die kleiner als {maxSize} MB ist",
	"neptune.UploadButton.allFileTypes": "Alle Dateiformate",
	"neptune.UploadButton.dropFiles": "Datei zum Hochladen in dieses Feld ziehen",
	"neptune.UploadButton.instructions": "{fileTypes}, kleiner als {size} MB",
	"neptune.UploadButton.maximumFiles": "Maximal {maxFiles} Dateien.",
	"neptune.UploadButton.uploadFile": "Datei hochladen",
	"neptune.UploadButton.uploadFiles": "Dateien hochladen",
	"neptune.UploadInput.deleteModalBody": "Wenn du diese Datei entfernst, wird sie aus unserem System gelöscht werden.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Abbrechen",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Entfernen",
	"neptune.UploadInput.deleteModalTitle": "Möchtest du diese Datei wirklich entfernen?",
	"neptune.UploadInput.fileIsTooLarge": "Die Datei ist zu groß",
	"neptune.UploadInput.fileTypeNotSupported": "Dateityp wird nicht unterstützt",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Leider ist das Hochladen fehlgeschlagen, da wir nicht mehr als {maxFilesAllowed} Dateien auf einmal akzeptieren können.",
	"neptune.UploadItem.deleting": "Wird gelöscht...",
	"neptune.UploadItem.removeFile": "Datei {filename} entfernen",
	"neptune.UploadItem.uploaded": "Hochgeladen",
	"neptune.UploadItem.uploadedFile": "Hochgeladene Datei",
	"neptune.UploadItem.uploading": "Wird hochgeladen...",
	"neptune.UploadItem.uploadingFailed": "Hochladen fehlgeschlagen"
};

export { de as default };
//# sourceMappingURL=de.json.mjs.map
